import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { noti } from '@/antds/Noti.tsx';
import i18n from '@/i18n';

function handleApiError(error: AxiosError<any>) {
  if (error.response?.status === 403) {
    noti.message.error('Unauthorized to access audio file.');
    return;
  }
  if (error.response?.data?.showMessage) {
    // TODO i18n handling for error messages from backend
    noti.message.error(error.response?.data?.message || i18n.t('common.error'));
  }
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error: Error) => {
      handleApiError(error as AxiosError);
    },
  }),

  mutationCache: new MutationCache({
    onError: (error: Error) => {
      handleApiError(error as AxiosError);
    },
  }),
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
    },
  },
});

export default queryClient;
